document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-copy-promo]');
  if (!button) return;

  var code = button.dataset.copyPromo;
  if (!code) return;

  var originalLabel = button.textContent;
  var copied = function () {
    button.textContent = 'Kopiert!';
    window.setTimeout(function () {
      button.textContent = originalLabel;
    }, 1600);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(copied).catch(function () {});
  }
});
